module.exports = __webpack_public_path__ + "img/syndromes.f586cb0a.svg";